import { FormattedMessage } from 'react-intl';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import { useAppDispatch } from '@redux/store';
import { handleGuestLogin } from 'modules/quick-search/helpers/guestLogin';

interface Props {
  open: boolean;
  onClose: () => void;
}

/** Khách bấm xem chi tiết / xem tiếp quá 3 HSNL → mời đăng nhập (docx 07.08 [85][91]). */
const GuestLoginCta = ({ open, onClose }: Props) => {
  const dispatch = useAppDispatch();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <FormattedMessage id="quickSearch.guestCtaTitle" />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          <FormattedMessage id="quickSearch.guestCtaBody" />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          <FormattedMessage id="back" />
        </Button>
        <Button variant="contained" onClick={() => handleGuestLogin(dispatch, onClose)}>
          <FormattedMessage id="quickSearch.guestCtaAction" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GuestLoginCta;
